// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.controlPanel__PTOTz {
  width: 50%;
  display: flex;
  flex-direction: column;
}

.controlLabel__L37rO {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  color: var(--title-inputs-sections-title);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
}
@media (max-width: 800px) {
  .controlLabel__L37rO {
    margin-bottom: 5px;
  }
}

.controlLabel__L37rO span::after {
  content: "*";
  font-size: 10px;
  line-height: 12px;
  color: var(--inputs-error-text-helper);
  margin-left: 5px;
}

.infoIcon__USZbM {
  width: 16px;
  height: 16px;
}

.photoType__MlnNg {
  margin-bottom: 25px;
}

.imageTypeRadioGroup__ziwaf {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 25px;
}
.imageTypeRadioGroup__ziwaf div {
  width: 130px;
}
@media (max-width: 1200px) {
  .imageTypeRadioGroup__ziwaf {
    margin-bottom: 15px;
  }
}

.radioButtonContainer__zkSFs,
.checkboxContainer__RMdkM {
  position: relative;
  display: flex;
  flex-direction: column;
  padding-top: 5px;
  gap: 10px;
  text-transform: none !important;
}

.pointsListContainer__IkEVs {
  border-radius: 2px;
  border: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-default);
  box-shadow: 0 0 1px 0 rgba(12, 26, 75, 0.24), 0 3px 8px -1px rgba(50, 50, 71, 0.05);
}

.instapointList__NJ0Bc {
  height: 100%;
}

.pointList__XLEdj {
  height: 184px;
  padding: 5px 15px 0;
  overflow-y: auto;
}
.pointList__XLEdj::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.pointList__XLEdj::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.pointList__XLEdj::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.pointList__XLEdj::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
@media (max-width: 1200px) {
  .pointList__XLEdj {
    height: 135px;
  }
}
@media (max-width: 800px) {
  .pointList__XLEdj {
    padding: 5px 10px 0;
    height: 85px;
  }
}

.withEquipmentCheckbox__OkaV8 {
  height: 143px;
}
@media (max-width: 1200px) {
  .withEquipmentCheckbox__OkaV8 {
    height: 94px;
  }
}
@media (max-width: 800px) {
  .withEquipmentCheckbox__OkaV8 {
    height: 66px;
  }
}

.equipmentCheckbox__TxY5k {
  padding: 10px 15px 12px;
  border-radius: 0 0 1px 1px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-secondary-row-sub-title-surface);
}
@media (max-width: 800px) {
  .equipmentCheckbox__TxY5k {
    padding: 3px 10px;
  }
}

.allCheckbox__OajVn {
  padding: 3px 5px;
  border-radius: 2px;
  border: 1px solid var(--buttons-surface);
}

.allCheckboxLabel__y8Wte p {
  color: var(--buttons-surface);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.controlPanelTooltip__kB1sx {
  max-width: 500px;
}

.disabledRadio__X74i8 label {
  color: var(--tabs-text-disable);
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/EditSensorGalleryModal/components/ControlPanel/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,UAAA;EACA,aAAA;EACA,sBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EAEA,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AA1EF;AA4EE;EAbF;IAcI,kBAAA;EAzEF;AACF;;AA4EA;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,sCAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,mBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAzEF;AA2EE;EACE,YAAA;AAzEJ;AA4EE;EAVF;IAWI,mBAAA;EAzEF;AACF;;AA4EA;;EAEE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;EACA,+BAAA;AAzEF;;AA4EA;EACE,kBAAA;EACA,kDAAA;EACA,qDAAA;EAEA,mFACE;AA3EJ;;AA+EA;EACE,YAAA;AA5EF;;AA+EA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AA5EF;AAvDE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAyDJ;AAtDE;EACE,+BAAA;EACA,kBAAA;AAwDJ;AArDE;EACE,8BAAA;EACA,kBAAA;AAuDJ;AApDE;EACE,gBAAA;EACA,kBAAA;AAsDJ;AA+DE;EAPF;IAQI,aAAA;EA5DF;AACF;AA8DE;EAXF;IAYI,mBAAA;IACA,YAAA;EA3DF;AACF;;AA8DA;EACE,aAAA;AA3DF;AA6DE;EAHF;IAII,YAAA;EA1DF;AACF;AA4DE;EAPF;IAQI,YAAA;EAzDF;AACF;;AA4DA;EACE,uBAAA;EACA,0BAAA;EACA,yDAAA;EACA,yDAAA;AAzDF;AA2DE;EANF;IAOI,iBAAA;EAxDF;AACF;;AA2DA;EACE,gBAAA;EACA,kBAAA;EACA,wCAAA;AAxDF;;AA4DE;EACE,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAzDJ;;AA6DA;EACE,gBAAA;AA1DF;;AA6DA;EACE,+BAAA;AA1DF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.controlPanel {\n  width: 50%;\n  display: flex;\n  flex-direction: column;\n}\n\n.controlLabel {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n\n  color: var(--title-inputs-sections-title);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n\n  @media (max-width: 800px) {\n    margin-bottom: 5px;\n  }\n}\n\n.controlLabel span::after {\n  content: '*';\n  font-size: 10px;\n  line-height: 12px;\n  color: var(--inputs-error-text-helper);\n  margin-left: 5px;\n}\n\n.infoIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.photoType {\n  margin-bottom: 25px;\n}\n\n.imageTypeRadioGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 25px;\n\n  div {\n    width: 130px;\n  }\n\n  @media (max-width: 1200px) {\n    margin-bottom: 15px;\n  }\n}\n\n.radioButtonContainer,\n.checkboxContainer {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  padding-top: 5px;\n  gap: 10px;\n  text-transform: none !important;\n}\n\n.pointsListContainer {\n  border-radius: 2px;\n  border: 1px solid var(--tables-primary-row-stroke);\n  background: var(--tables-primary-row-surface-default);\n\n  box-shadow:\n    0 0 1px 0 rgba(12, 26, 75, 0.24),\n    0 3px 8px -1px rgba(50, 50, 71, 0.05);\n}\n\n.instapointList {\n  height: 100%;\n}\n\n.pointList {\n  height: 184px;\n  padding: 5px 15px 0;\n  overflow-y: auto;\n\n  @include scrollBar;\n\n  @media (max-width: 1200px) {\n    height: 135px;\n  }\n\n  @media (max-width: 800px) {\n    padding: 5px 10px 0;\n    height: 85px;\n  }\n}\n\n.withEquipmentCheckbox {\n  height: 143px;\n\n  @media (max-width: 1200px) {\n    height: 94px;\n  }\n\n  @media (max-width: 800px) {\n    height: 66px;\n  }\n}\n\n.equipmentCheckbox {\n  padding: 10px 15px 12px;\n  border-radius: 0 0 1px 1px;\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n  background: var(--tables-secondary-row-sub-title-surface);\n\n  @media (max-width: 800px) {\n    padding: 3px 10px;\n  }\n}\n\n.allCheckbox {\n  padding: 3px 5px;\n  border-radius: 2px;\n  border: 1px solid var(--buttons-surface);\n}\n\n.allCheckboxLabel {\n  p {\n    color: var(--buttons-surface);\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18px;\n  }\n}\n\n.controlPanelTooltip {\n  max-width: 500px;\n}\n\n.disabledRadio label {\n  color: var(--tabs-text-disable);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"controlPanel": `controlPanel__PTOTz`,
	"controlLabel": `controlLabel__L37rO`,
	"infoIcon": `infoIcon__USZbM`,
	"photoType": `photoType__MlnNg`,
	"imageTypeRadioGroup": `imageTypeRadioGroup__ziwaf`,
	"radioButtonContainer": `radioButtonContainer__zkSFs`,
	"checkboxContainer": `checkboxContainer__RMdkM`,
	"pointsListContainer": `pointsListContainer__IkEVs`,
	"instapointList": `instapointList__NJ0Bc`,
	"pointList": `pointList__XLEdj`,
	"withEquipmentCheckbox": `withEquipmentCheckbox__OkaV8`,
	"equipmentCheckbox": `equipmentCheckbox__TxY5k`,
	"allCheckbox": `allCheckbox__OajVn`,
	"allCheckboxLabel": `allCheckboxLabel__y8Wte`,
	"controlPanelTooltip": `controlPanelTooltip__kB1sx`,
	"disabledRadio": `disabledRadio__X74i8`
};
module.exports = ___CSS_LOADER_EXPORT___;
